import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./ReorderExercisesModal.css";

const ReorderExercisesModal = ({
  exercises,
  onSave,
  onCancel,
}) => {
  // Ensure exercises have unique IDs for drag and drop
  const exercisesWithIds = exercises.map((exercise, index) => ({
    ...exercise,
    uniqueId: exercise.id || exercise.exercise_id || `exercise-${index}-${exercise.name?.substring(0, 10)}`
  }));

  const [reorderedExercises, setReorderedExercises] = useState(exercisesWithIds);

  console.log("ReorderExercisesModal rendering with exercises:", exercises);
  console.log("Exercises with IDs:", exercisesWithIds);

  const handleDragEnd = (result) => {
    console.log("Drag ended:", result);
    
    if (!result.destination) {
      console.log("No destination, drag cancelled");
      return;
    }

    if (result.destination.index === result.source.index) {
      console.log("Same position, no change needed");
      return;
    }

    const items = Array.from(reorderedExercises);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    console.log("New order:", items.map((item, idx) => `${idx + 1}. ${item.name} . ${item.id}`));
    setReorderedExercises(items);
  };

  const handleSave = () => {
    console.log("handleSave order:", reorderedExercises.map((item, idx) => `${idx + 1}. ${item.name} . ${item.id}`));
    onSave(reorderedExercises);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="reorder_modal-backdrop" onClick={handleBackdropClick}>
      <div className="reorder_modal-container">
        <div className="reorder_modal-header">
          <h2 className="reorder_modal-title">
            <i className="fa fa-sort" style={{ marginRight: '12px' }}></i>
            Reorder Exercises
          </h2>
          <button 
            className="reorder_modal-close"
            onClick={onCancel}
            aria-label="Close modal"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>

        <div className="reorder_modal-content">
          <div className="reorder_instructions">
            <div className="reorder_instructions-icon">
              <i className="fa fa-info-circle"></i>
            </div>
            <div className="reorder_instructions-text">
              <p><strong>Drag and drop</strong> exercises to change their order.</p>
              <p>The exercise at the top will be performed first.</p>
            </div>
          </div>

          <div className="reorder_exercise-list">
            <DragDropContext 
              onDragEnd={handleDragEnd}
              onDragStart={(start) => {
                console.log("Drag started:", start);
              }}
              onDragUpdate={(update) => {
                console.log("Drag update:", update);
              }}
            >
              <Droppable droppableId="exercise-reorder-list">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className={`reorder_droppable-area ${
                      snapshot.isDraggingOver ? 'reorder_dragging-over' : ''
                    }`}
                  >
                    {reorderedExercises?.map((exercise, index) => {
                      const exerciseId = exercise.uniqueId;
                      return (
                        <Draggable
                          key={exerciseId}
                          draggableId={exerciseId.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className={`reorder_exercise-item ${
                                snapshot.isDragging ? 'reorder_dragging' : ''
                              }`}
                              style={{
                                ...provided.draggableProps.style,
                                cursor: 'grab'
                              }}
                            >
                              <div className="reorder_exercise-number">
                                {index + 1}
                              </div>
                              <div className="reorder_exercise-content">
                                <div className="reorder_exercise-name">
                                  {exercise.name}
                                </div>
                                <div className="reorder_exercise-meta">
                                  {exercise.sets && exercise.sets.length > 0 && (
                                    <span className="reorder_meta-item">
                                      <i className="fa fa-list"></i>
                                      {exercise.sets.length} sets
                                    </span>
                                  )}
                                  {exercise.duration && (
                                    <span className="reorder_meta-item">
                                      <i className="fa fa-clock"></i>
                                      {exercise.duration}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div 
                                className="reorder_drag-handle"
                                {...provided.dragHandleProps}
                                style={{ cursor: 'grab' }}
                              >
                                <i className="fa fa-grip-vertical"></i>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>

        <div className="reorder_modal-footer">
          <button
            className="reorder_btn reorder_btn-cancel"
            onClick={onCancel}
          >
            <i className="fa fa-times" style={{ marginRight: '8px' }}></i>
            Cancel
          </button>
          <button
            className="reorder_btn reorder_btn-save"
            onClick={handleSave}
          >
            <i className="fa fa-check" style={{ marginRight: '8px' }}></i>
            Save Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReorderExercisesModal;
